require("core-js/modules/es6.object.assign");

var _objectWithoutProperties = require("/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.define-property");

var $eQpDd$babelruntimehelpersextends = require("@babel/runtime/helpers/extends");

var $eQpDd$react = require("react");

var $eQpDd$radixuireactprimitive = require("@radix-ui/react-primitive");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a["default"] : a;
}

$parcel$export(module.exports, "Arrow", function () {
  return $09f4ad68a9251bc3$export$21b07c8f274aebd5;
});
$parcel$export(module.exports, "Root", function () {
  return $09f4ad68a9251bc3$export$be92b6f5f03c0fe9;
});
/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/

var $09f4ad68a9251bc3$var$NAME = 'Arrow';
var $09f4ad68a9251bc3$export$21b07c8f274aebd5 = /*#__PURE__*/$eQpDd$react.forwardRef(function (props, forwardedRef) {
  var children = props.children,
      _props$width = props.width,
      width = _props$width === void 0 ? 10 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 5 : _props$height,
      arrowProps = _objectWithoutProperties(props, ["children", "width", "height"]);

  return /*#__PURE__*/$eQpDd$react.createElement($eQpDd$radixuireactprimitive.Primitive.svg, $parcel$interopDefault($eQpDd$babelruntimehelpersextends)({}, arrowProps, {
    ref: forwardedRef,
    width: width,
    height: height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /*#__PURE__*/$eQpDd$react.createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
/*#__PURE__*/

Object.assign($09f4ad68a9251bc3$export$21b07c8f274aebd5, {
  displayName: $09f4ad68a9251bc3$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/

var $09f4ad68a9251bc3$export$be92b6f5f03c0fe9 = $09f4ad68a9251bc3$export$21b07c8f274aebd5;